/*
 * @Author: 曹捷
 * @Date: 2021-02-01 10:34:22
 * @LastEditors: 曹捷
 * @LastEditTime: 2022-07-04 11:07:39
 * @Description: 主框架配置
 */
let isDev = process.env.MODE === 'development'
import themeServer from 'obit-wui/config/theme'
import UploadSDK from 'obit-wui/utils/upload/qiniu'
import MinioSDK from 'obit-wui/utils/upload/minio'
import themeInfo from './style/theme/industrial.json'
export default function (app) {
  return {
    layout: 'layoutLeft',
    title: '工业互联网SAAS平台',
    TokenKey: 'SAAS-TOKEN',
    roleKey: 'SAAS-ROLE',
    // 是否是乾坤环境  即子应用集成在主框架中
    isQianKun: window.__POWERED_BY_QIANKUN__,
    subApp: false,
    foot: {
      text: 'Copyright © 2021 湖南易比特大数据有限公司',
    },
    async beforeMounted ({ http }) {
      let data = await http.sysPost('system/config/getFileConfigMode')
      let uploadConfig = JSON.parse(data)
      if (uploadConfig.mode === 'MINIO') {
        // 引入Minio 上传SDK
        app.config.globalProperties.uploadSDK = new MinioSDK(Object.assign({ bucketName: 'saas', http, appName: 'CENTER' }, uploadConfig))
      } else if (uploadConfig.mode === 'QINIU') {
        // 引入七牛云SDK
        app.config.globalProperties.uploadSDK = new UploadSDK(uploadConfig.bucketName, http, 'CENTER', this.TokenKey)
      }
    },
    theme: {
      theme: 'industrial'
    },
    header: {
      height: 90
    },
    breadcrumb: {
      fixed: false,
      position: 'navbar',
      height: '50px'
    },
    table: {
      // 表格高度固定 内部滚动
      fixed: true
    },
    auth: {
      // 登录页面  路由地址
      loginURL: '/login',
      homeURL: '/home',
      appHome: true,
      // 系统应用编码  必填
      appCode: '',
    },
    menu: {
      width: 180,
      trigger: null,
      key: 'name',
      // 展示的菜单名称
      name: 'title',
      iconName: 'icon',
      // 多级菜单  子集对象名
      children: 'children',
      // 跳转路径
      url: 'path',
      // 上下级关系
      parentId: 'pId',
      // 上下级关系
      id: 'selfId'
    },
    logo: {
      show: 'navbar',
      // icon: 'icon-logo1',
      title: '工业SAAS',
      // trigger: false
    },
    mounted () {
      themeServer.addTheme('industrial', themeInfo)
      themeServer.changeCssTheme('industrial')
    }
  }
}